/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import React from 'react'
import styled from 'styled-components'
import ButtonShell from './ButtonShell'

const StyledButton = styled.div`
  background-color: ${props => props.theme.color.contrast};
  display: inline-block;
  transition: transform 0.25s;

  &:hover {
    transform: scale(1.05);
  }
  
  & > a, & > button {
    font-family: ${props => props.theme.font.family.secondaryAlt};
    font-size: ${props => props.theme.font.size.m};
    color: ${props => props.theme.color.text.light} !important;
    padding: 10px 15px;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
  }
`

const ButtonDefault = ({ isAnchor, isCustom, to, children, className }) => (
  <StyledButton className={className}>
    {isCustom ? children : (
      <ButtonShell to={to} isAnchor={isAnchor}>
        {children}
      </ButtonShell>
    )}
  </StyledButton>
)

export default ButtonDefault